import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import currentRegion from '@/reducers/currentRegion'
import { create } from '@/reducers/lineItems/asyncActions'
import { quantitySelector } from '@/selectors'
import priceFactory from '@/utils/factory/price/priceFactory'
import { routeFor } from '@/utils/router'

import AddToCart from './AddToCart'
import ProductImageLink from './ProductImageLink'
import ProductInfo from './ProductInfo'
import VariantSelector from './VariantSelector'

const STUDENT_PRICE = 'StudentPrice'
const CART_RECOMMENDATIONS = 'Cart Recommendations'
const CART_RECOMMENDED = 'Recommended Products Cart'
const CART_RECOMMENDED_ID = 'recommended_products_cart'
const list = {
  listId: CART_RECOMMENDED_ID,
  listName: CART_RECOMMENDED,
  listType: CART_RECOMMENDATIONS
}

const RelatedAsset = ({ assetKey }) => {
  const asset = useSelector(state => state.relatedAssets.assets[assetKey])
  const {
    edition,
    id,
    productImageUrl,
    selectedVariant,
    slug,
    title,
    variantOptions
  } = asset
  const assetsOrder = useSelector(state => state.relatedAssets.assetsOrder)
  const position = assetsOrder.indexOf(assetKey)
  const { studentPrice } = selectedVariant
  const quantity = useSelector(quantitySelector)
  const price = priceFactory.createPrice(STUDENT_PRICE, { studentPrice })

  const dispatch = useDispatch()

  const addToCart = event => {
    event.preventDefault()

    dispatch(create({ quantity, variantId: selectedVariant.id }))

    dispatch(
      {
        payload: {
          asset: asset,
          currentRegion: currentRegion,
          list: list,
          position: position,
          variant: selectedVariant
        },
        type: 'gtm/addToCart'
      }
    )
  }

  const productClick = event => {
    event.preventDefault()

    dispatch(
      {
        payload: {
          asset: asset,
          list: list,
          position: position,
          variant: selectedVariant
        },
        type: 'gtm/productClick'
      }
    )

    window.location.assign(routeFor('asset', { id: slug }))
  }

  return (
    <div className='row' id={'related-asset-' + id}>
      <div className='col-sm-10 clearfix'>
        <div className='product-info__image-container'>
          <ProductImageLink
            action={productClick}
            productImageUrl={productImageUrl}
            slug={slug}
          />
        </div>
        <div className='product-info__details'>
          <div className='d-block'>
            <ProductInfo {...{ edition, productClick, title }} />
          </div>
          <VariantSelector
            assetId={id}
            selectedVariant={selectedVariant}
            variantOptions={variantOptions}
          />
          <AddToCart action={addToCart} title={title} />
        </div>
      </div>
      <div className='col-sm-2'>
        <div className='u-align--right u-weight--medium'>
          {price.formattedAmount}
        </div>
      </div>
    </div>
  )
}

RelatedAsset.propTypes = {
  assetKey: PropTypes.number.isRequired
}

export default RelatedAsset
